/* Phone controller relay for the 3D farm (written by install-remote.sh) */
window.GLLF_REMOTE_URL = 'https://gllf-sim-remote-l54lvix44a-uc.a.run.app';
